import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GlobalFuntions } from 'app/_helpers';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'common-dialog',
  templateUrl: './common-dialog.component.html',
  styleUrls: ['./common-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CommonDialogComponent implements OnInit {
  public htmlMobile = '' as string;
  public htmlWhatsApp = '' as string;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

  formattedPhoneNumber: string = '';

  constructor(
    public dialogRef: MatDialogRef<CommonDialogComponent>,
    private _globalFuntions: GlobalFuntions,
    public _translateService: TranslateService,
    private _matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _globalFunctions: GlobalFuntions
  ) {

    if (this._data) {
      if (this._data.type === 'client') {
        this._data.model = 'client';
        this._data.activity_type = 'Call to client';
      } else if (this._data.type === 'commercial_properties') {
        this._data.model = 'commercial_properties'
        if (this._data.to_agency)
          this._data.activity_type = 'Call to Business';
      } else if (this._data.type === 'users') {
        this._data.model = 'users'
        this._data.activity_type = 'Call to User';
      }
    }
  }

  ngOnInit(): void {
    const countryCode = this._data.mobile_country;
    const phoneNumber = this._data.mobile_number;
    this.formattedPhoneNumber = this._globalFunctions.formatPhoneNumber(countryCode, phoneNumber);

    this.htmlMobile += `${this._translateService.instant('mobile_phone')}: <span class="blue-500-fg">${this.formattedPhoneNumber}</span>`;
    this.htmlWhatsApp += `<a class="font-size-20 green-500-fg"><span class="fab fa-whatsapp"></span></a> <br>`;
  }

  openWhatsapp(): void {
    //Note: Reason to not using this.formattedPhoneNumber here is that: phone should not contains spaces and leading plus sign(+)
    window.open(`https://api.whatsapp.com/send?phone=${this._data.mobile_country + this._data.mobile_number}`, `_blank`);
    if (this._data.url) {
      window.open(`https://api.whatsapp.com/send?phone=${this._data.mobile_country + this._data.mobile_number}&text=${this._data.url}`, `_blank`);
    }
  }

  mobile(): void {
    this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to make call?';
    this.confirmDialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this._globalFuntions.onCallMobile(this._data, this._data.mobile_country + this._data.mobile_number);
      }
    });
    this.dialogRef.close(false);
  }
}
